import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import { LmsTeacherAPIServiceV2 } from '@protos/learning_management/lms.teacher.apis_connect';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';

export const LmsTeacherAPIServiceV1Client = createPromiseClient(
  LmsTeacherAPIServiceV2,
  lmsTransport
);

export const useLmsTeacherAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsTeacherAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
